var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeciality14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c,.d{fill:none;stroke:#208ce1;stroke-width:1.5px;}.c{stroke-linecap:round;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-942 -7997)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(942 7997)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-920.651-7971.43s2.791-3.846,0-4.751c-.226-1.81-.226-4.3-2.338-4.751-.679-1.056.253-4.321-1.771-4.4s-1.46,3.8-1.623,4.4-2.723.84-1.961,3.394"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-927.245-7971.43s-2.791-3.846,0-4.751c.226-1.81.226-4.3,2.338-4.751.679-1.056-.253-4.321,1.771-4.4s1.46,3.8,1.623,4.4,2.723.84,1.961,3.394",
    transform: "translate(14.997)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-925.328-7977.086s-6.762-1.837-4.805,5.646c-.085,4.426,1.017,5.3,3.4,5.645.522.116.478.183.478.183"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-930.488-7977.086s6.762-1.837,4.805,5.646c.085,4.426-1.017,5.3-3.4,5.645-.522.116-.427,0-.427,0",
    transform: "translate(22.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-924.59-7968.87s-3.3,2.955-.539,5.106,6.167-1.625,6.167-1.625a3.692,3.692,0,0,1,4-.291c2.321,1.161,2.031,2.321,4.409,2.727s6.034-2.668,2.089-5.917"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-926.326-7973.1c-.2.107,2.375-1.281,3.229,1.961"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-923.108-7973.1c.2.107-2.375-1.281-3.229,1.961",
    transform: "translate(17 -0.287)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-919.589-7973.31h6.159"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-919.589-7973.31h6.159",
    transform: "translate(-0.058 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-920.616-7978.6a2.618,2.618,0,0,0,2.053-.446,3.344,3.344,0,0,1,2.516-.6,11.7,11.7,0,0,1,1.875.845,4.529,4.529,0,0,0,2.033.343"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-925.753-7987.974s-.464-5.57,2.9-7.31-2.321,4.467-.522,5.337,1.972-2.843,3.655-1.218,1.508,4.7,3.945,3.887.232-3.133,2.785-3.307,2.669,1.915,3.423,1.276-.246-4.188-1.276-4.931c-.536-.386-.034-1.129,1.276-.88.775.264,2.044,1,2.379,3.955a24.516,24.516,0,0,1,0,3.191",
    transform: "translate(0 0.648)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-922.223-7962.917V-7954s.534,4.3,5.954,4.185,5.134-4.185,5.134-4.185v-8.915"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-922.223-7954.873a13.3,13.3,0,0,0,11.066,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-922.223-7954.873a13.3,13.3,0,0,0,11.066,0",
    transform: "translate(0 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-922.223-7954.873a13.3,13.3,0,0,0,11.066,0",
    transform: "translate(0.215 -8.044)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality14);
export default __webpack_public_path__ + "static/media/speciality14.b6d674987b7643de1ba2b9033b08106c.svg";
export { ForwardRef as ReactComponent };